export default __webpack_public_path__ + "static/media/humidifier.89137a8a.svg";